var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliberation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Shipping-Box-1--Streamline-Sharp",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Shipping Box 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shipping-box-1--box-package-label-delivery-shipment-shipping"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    stroke: "#fff",
    d: "M1.0605 22.9395V1.0605H22.9395V22.9395H1.0605Z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    stroke: "#fff",
    d: "M8.7181 1.0605V10.906L12 8.7181L15.2819 10.906V1.0605",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    stroke: "#fff",
    d: "M14.1879 18.5637H18.5637",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliberation);
export default __webpack_public_path__ + "static/media/DELIBERATION.0237aa3d3ac8f63ed8d936cc140ee80f.svg";
export { ForwardRef as ReactComponent };